// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-vantage -> weidner-apartment-homes-vantage -> wyndham-crossing
// Generated: 2026-10-27T17:09:21.519Z
// Counts: 0 design, 21 content, 16 slot group, 0 collection binding, 9 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "right-middle",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>In <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-loader.inject_dni_classes": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "facebook-pixel.pixel_ids": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_pixel_id"
  },
  "footer.social_label": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p><span style=\"font-size: 11pt;\">Pit Bull &amp; Pit Bull Mixes&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">American Pit Bull Terrier&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">American Staffordshire Terrier&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Wolf Hybrids&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Doberman Pinscher&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Saint Bernard&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">American Bulldog&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Staffordshire Bull Terrier&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Rottweiler&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">German Shepherd&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Chow Chow&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Great Dane&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Akita&nbsp;</span></p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the comforts waiting for you at Wyndham Crossing in Edmonton, AB. Inside every apartment, you’ll enjoy thoughtful touches like large closets, linen storage, and spacious dining rooms. Step out to your private patio or balcony for fresh air, or store your extras with ease thanks to the large storage rooms. Around the community, relax year-round at the indoor pool, unwind in the lush courtyard, or join exclusive resident events. Everyday routines are easier with on-site parking, laundry, and ready access to parks, shops, and public transit.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Have questions about living at Wyndham Crossing? Our leasing professionals are here to guide you through floor plans, available homes, or the application process. Reach out online or request a personal virtual tour - we look forward to connecting with you and introducing you to our warm Edmonton community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Step into flexible living with floor plans at Wyndham Crossing Apartments in Edmonton, AB. Select from thoughtfully designed one, two, and three-bedroom layouts, each offering expansive kitchen storage, a dedicated dining area, and generous closets. Bright windows fill your private living areas with natural light, while optional patios and balconies provide a sunny spot for morning coffee. Whether you work remotely, want space to relax, or crave extra storage, our floor plans adapt to your lifestyle in northeast Edmonton.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a visual stroll through Wyndham Crossing’s photo gallery in Edmonton, AB. Peek inside spacious apartments filled with sunlight, kitchens ready for weekend baking, and inviting communal spaces meant for gathering or quiet time. Notice the green courtyards and cozy patios that beckon at the end of your day. Let each photo help you imagine how every detail comes together for a warm, welcoming lifestyle in northeast Edmonton.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Surround yourself with Edmonton’s vibrant energy at Wyndham Crossing. Located northeast of downtown, you’re moments from River Valley, Clareview Rec Center, and Canada Place. Running errands is simple with Highway 15 and Anthony Henday Drive nearby, plus Costco, Walmart Supercentre, and Real Canadian Superstore close to home. On your days off, explore Rundle Park, catch the latest at Cinema City Movies, or enjoy West Edmonton Mall, fitness centres, and restaurants just minutes away. From shops to green spaces and easy access to major employers, this is city living that puts everything at your fingertips.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Wyndham Crossing stands at the heart of northeast Edmonton, offering you easy access to shopping, dining, and Edmonton’s lush parks. Just minutes from Highway 15 and Anthony Henday Drive, your journeys around the city are a breeze. Fulfill your shopping list at Costco or Walmart Supercentre, catch a movie at Cinema City Movies, or stroll through Rundle Park. With West Edmonton Mall, fitness centres, and local restaurants nearby, there’s always something to explore. Convenience and connection come together near River Valley, Clareview Rec Center, and Canada Place, all close to home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Searching for apartments for rent in Edmonton, AB? Wyndham Crossing is your launchpad for daily living. Picture returning home to your choice of one-, two-, or three-bedroom apartments, tucked near River Valley and Canada Place. Whether you love morning walks around Clareview Recreation Centre or picking up dinner just around the corner, our vibrant community lets you spend less time commuting and more time enjoying life at home. Wyndham Crossing offers pet-friendly living, renovated homes, and easy access to public transit, so you always feel connected and comfortable in northeast Edmonton.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to see Wyndham Crossing up close? Choose from in-person tours by appointment, guided virtual walkthroughs with our leasing team, or a virtual tour. Whether you want to stroll the grounds in person or explore from the comfort of home, we make it simple for you. Restrictions may apply to some tour types - reach out for the options that suit you best.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a virtual stroll through Wyndham Crossing from wherever you are. This online tour lets you explore different layouts, see how sunlight fills each room, and get a feel for Edmonton’s energetic community atmosphere. From cozy corners to open community paths, the virtual tour helps you picture life at Wyndham Crossing before you visit in person. It’s a helpful first step to see if our northeast Edmonton apartments feel like your future home.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "multihub-lead-form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": "/thank-you"
      }
    }
  },
  "contactform.form.success_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "footer.contact_us_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "contact-hero.bg_image": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "floor-plans-hero.bg_image": {
    "sourceIndex": 2,
    "fieldOverrides": null
  },
  "future-residents-club-hero.bg_image": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "gallery-hero.bg_image": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-8954-71a4-952e-7ab61d870391.webp"
      }
    }
  },
  "neighborhood-hero.bg_image": {
    "sourceIndex": 16,
    "fieldOverrides": null
  },
  "pet-policy-hero.bg_image": {
    "sourceIndex": 16,
    "fieldOverrides": null
  },
  "schedule-tour-hero.bg_image": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": 9,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 8
    }
  ]
};

export const styleOverrides = {};
